import React from 'react';
import { Box } from '@mui/material';
import { Popup, PopupSettings } from 'components/common/popup/Popup';
import parse from 'html-react-parser';
import showdown from 'showdown';

const converter = new showdown.Converter();
export default function ErrorPopup({
    open,
    message,
    settings,
    onHide,
}: {
    open: boolean;
    message: string;
    settings: PopupSettings;
    onHide: () => void;
}) {
    return (
        <Popup settings={settings} open={open} onHide={onHide} maxWidth={'popupSm'}>
            <Box>{parse(converter.makeHtml(message))}</Box>
        </Popup>
    );
}
